module.exports = __webpack_public_path__ + "static/media/24-7.77f0115d.mp3";